export class BBCRiskAnalysisRow{
    public AuditName:string = "";
    public QuestionHeader:string = "";
    public AnswerText:string = "";
    public RowTotal:number = 0;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}